import libphonenumber from 'google-libphonenumber';
export const validateEmail = str => {
    const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return reg.test(String(str).toLowerCase());
};
const phoneUtil = libphonenumber.PhoneNumberUtil.getInstance();
export const validatePhone = phone => {
    try {
        const phoneNumber = phoneUtil.parse(phone);
        return phoneUtil.isValidNumber(phoneNumber);
    }
    catch (error) {
        return false;
    }
};
export const populateEmail = str => {
    if (validateEmail(str))
        return true;
    else if (str.includes('@'))
        return true;
    return false;
};
export const populatePhone = str => {
    const reg = /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g;
    if (validatePhone(str))
        return true;
    else
        return reg.test(String(str).toLowerCase());
};
